export const getEveryTravelService = (state) => state.everyTravel;
